import React from 'react';
import { Route, BrowserRouter, Switch } from 'react-router-dom';
import ProtectedRoute from 'autenticacion_protectedroute';
import Inicio from '../Online/Inicio';
import Callback from 'autenticacion_callback';
import { ErrorAutenticacion, NoEncontrado, NoEncontradoGenerico } from 'errores';
import Consultar from '../Offline/Consultar';
import 'bootstrap/dist/css/bootstrap.css';
import { Footer, Header } from 'componentes_nav';
import './fonts.css';
import './App.css';
import Compra from '../Offline/Compra';
import Historial from '../Online/Historial';
import PantallaGenericaMovil from '../Offline/PantallaGenericaMovil';
import logo_vw from './imgs/logo_vw.svg';
import Unsuscribe from '../Utils/Unsuscribe';
import TerminosCondiciones from '../TerminosCondiciones';
const App = {
  dependencies: {
    featureServices: {
      'dto:servicio:autenticacion': '^1.0.0',
      'dto:servicio:firebase': '^0.1.0'
    }
  },
  create(env) {/*
    const config = {
      apiKey: "AIzaSyASZ-DRpGHy6MeAPbcG30UUYCL6JFftkAs",
      authDomain: "keepmeinformed-d7b76.firebaseapp.com",
      databaseURL: "https://keepmeinformed-d7b76.firebaseio.com",
      projectId: "keepmeinformed-d7b76",
      storageBucket: "keepmeinformed-d7b76.appspot.com",
      messagingSenderId: "49998780858",
      appId: "1:49998780858:web:435aca613730ce6ed2a583",
      measurementId: "G-RVN85C735Y"
    };*/
    const servicio = env.featureServices['dto:servicio:autenticacion'];
    const servicioFirebase = null;//env.featureServices['dto:servicio:firebase'];
    //servicioFirebase.inicializar(config);

    return {
      render() {
        return (
          <BrowserRouter>
            <Switch>
                <Route path="/es/app/sigue-tu-volkswagen/vw/oauth/callback.html" exact={true} render={routeProps => (<Callback servicio={servicio} spinner={true} {...routeProps} />)} />
                <Route path="/es/app/sigue-tu-volkswagen/error/autenticacion/dto" exact={true} >
                    <ErrorAutenticacion error="VWM" servicio={servicio} logo={logo_vw} />
                </Route>
                <Route path="/es/app/sigue-tu-volkswagen/error/autenticacion/id" exact={true} >
                    <ErrorAutenticacion error="Identity Kit" servicio={servicio} logo={logo_vw} />
                </Route>
                <Route exact={true} path="/es/app/sigue-tu-volkswagens/noEncontrado">
                    <Header marca="vw" links={[{ link: "https://www.vw.com.mx/es/legal/aspectos-legales.html", "texto": "Legales" }]} />
                    <NoEncontrado marca="vw" nombreApp="KMI" url="/es/app/sigue-tu-volkswagen/vw/inicio" />
                    <Footer marca="vw" />
                </Route>
                <ProtectedRoute exact={true} servicio={servicio} servicioFirebase={servicioFirebase} path="/es/app/sigue-tu-volkswagen/vw/inicio.html" marca="vw" component={Inicio} />
                <Route exact={true} path="/es/app/sigue-tu-volkswagen/vw/config/contacto.html/:data" servicioFirebase={servicioFirebase} render={props => <Unsuscribe marca="vw" {...props}/>} />
                <ProtectedRoute exact={true} path="/es/app/sigue-tu-volkswagen/vw/historial.html" servicio={servicio} marca="vw" servicioFirebase={servicioFirebase} component={Historial} />
                <ProtectedRoute exact={true} path="/es/app/sigue-tu-volkswagen/vw/terminosycondiciones.html" servicio={servicio} marca="vw" servicioFirebase={servicioFirebase} padre={false} component={TerminosCondiciones} />
                
                <Route exact={true} path="/es/app/sigue-tu-volkswagen/vw/consultar.html">
                    <Consultar marca="vw" servicioFirebase={servicioFirebase} />
                </Route>
                <Route exact={true} path="/es/app/sigue-tu-volkswagen/vw/compra.html" render={routeProps => (
                    <div>
                    <Compra marca="vw" servicioFirebase={servicioFirebase} {...routeProps} offline={true} />
                    </div>
                )} />
                <Route exact={true} path="/es/app/sigue-tu-volkswagen/inicio.html">
                    <PantallaGenericaMovil />
                </Route>
                <Route>
                <NoEncontradoGenerico nombreApp="KMI" logo={logo_vw}
                  links={
                    [
                      { url: "/audi/inicio", texto: "Audi" },
                      { url: "/vw/inicio", texto: "Volkswagen" },
                      { url: "/seat/inicio", texto: "Seat" }
                    ]
                  }
                />
              </Route>
            </Switch>
          </BrowserRouter>
        );
      }
    }
  }
}

export default App;
